import React from 'react';
import {
  DialogContent,
  Paper
} from '@material-ui/core';
import moment from 'moment';
import Draggable from 'react-draggable';

import DefaultImage from 'images/defaultAndEmpties/defaultNoProductImageMediumRectangleLightGrayBg.svg';

import { PrintProductTopInfos, PrintProductBottomInfos, LabelDetailsDialogContainer } from '../../styles';
import ValidationLength from 'utils/utils';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintingStockExtractsDialog"
      cancel={'input,textarea,button,[class*="MuiInputBase-root"],[role="button"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function LabelDetailsDialog({ open, onClose, labelItem }) {
  if (!labelItem) return null;

  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const currentUserName = userLocal?.user || 'Usuário';

  const titleText = `${labelItem?.productDescription || 'PRODUTO'}${labelItem?.conservation?.abbreviation
    ? ` (${String(labelItem.conservation.abbreviation).toUpperCase()})`
    : ''
    }`;

  const qtyLabel = Number(labelItem?.quantity || 0)
    .toFixed(3)
    .replace('.', ',');

  const formatDateTime = (d) =>
    d ? moment(d).format('DD/MM/YYYY HH:mm') : '00/00/0000 00:00';

  const unitAbbr =
    (labelItem?.unitAbbreviation ||
      labelItem?.consumptionUnitAbbreviation ||
      labelItem?.consumptionUnitsPrimary?.abbreviation ||
      ''
    ).toString()

  return (
    <LabelDetailsDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperComponent={PaperComponent}
    >
      <DialogContent
        id="draggableLabelPrintingStockExtractsDialog"
        style={{ cursor: 'move' }}
      >
        <PrintProductTopInfos>
          <div className="productDescriptionAndStockValue mr8">
            <span className="title">

              {ValidationLength(
                titleText,
                60
              )}

            </span>
            <span className="defaultItemLine">
              QTDE: <span className="lineValue">{qtyLabel}{unitAbbr ? ` ${unitAbbr}` : ''}</span>

            </span>
          </div>

          <img
            src={
              labelItem?.productImageUrl ||
              labelItem?.image?.url ||
              DefaultImage
            }
            alt={labelItem?.productDescription || 'produto'}
          />
        </PrintProductTopInfos>

        <PrintProductBottomInfos>
          <span className="defaultItemLine">
            Manipulação:{' '}
            <span className="lineValue">
              {formatDateTime(labelItem?.manipulatedAt || labelItem?.createdAt)}
            </span>
          </span>

          <span className="defaultItemLine">
            Validade:{' '}
            <span className="lineValue">
              {formatDateTime(labelItem?.validAt)}
            </span>
          </span>

          <span className="defaultItemLine">
            Responsável:{' '}
            <span className="lineValue">
              {currentUserName}
            </span>
          </span>
        </PrintProductBottomInfos>
      </DialogContent>
    </LabelDetailsDialogContainer>
  );
}
